import { setLocalSession } from "./auth";
import { RoutesPage } from "./RoutesPage";

const App = () => {
  if (process.env.NODE_ENV !== "development") {
    console.log =
      console.error =
      console.info =
      console.debug =
      console.warn =
        function () {};
  }
  
  setLocalSession();
  return <RoutesPage />;
};

export default App;
